import { Fragment, useState } from "react";

import { MegaMenu } from "primereact/megamenu";
import { UseInvoiceReportService as Service } from "./UseInvoiceReportService";

import { FormatDisplay } from "../../../shared/format";
import { Filter } from "../filter";

import cookie from "cookiejs";
import { ToastService } from "../../../AppToast";
import {
  createJob,
  ERROR,
  getCurrentJob,
  getDetailJobById,
  IN_PROGRESS,
  INVOICE_SYNTHESIZE_REPORT,
  loginJob,
  SUCCESS,
  USE_INVOICE_REPORT,
} from "../../../service/ExportService";
import { checkLoginRequired } from "../../../utils/helperExportExcel";
import { useDialogExportContext } from "../../context/DialogExportContext";

export default function TinhHinhSuDung() {
  const [displayFilter, setDisplayFilter] = useState(null);
  const [filter, setFilter] = useState({});

  const [items, setItems] = useState([]);
  const [isTableEmpty, setIsTableEmpty] = useState(true);

  const { setVisible, setStatus, status, setJobDetail, setMinimize } =
    useDialogExportContext();

  const downloadExcel = () => {
    Service.downloadExcel(filter).then((data) => {
      const link = document.createElement("a");
      link.href = window.URL.createObjectURL(new Blob([data]));
      link.download = `bao-cao-tinh-hinh-su-dung-hoa-don.xlsx`;
      link.click();
    });
  };

  const search = (params) => {
    setFilter(params);
    setDisplayFilter(false);

    Service.getList(params).then((data) => {
      setItems(data);
      setIsTableEmpty(!data || data.length === 0);
    });
  };

  const TENNANT_ID = localStorage.getItem("iam-m-invoice-react.v1.0.0_tenant");

  const getDetailJobRunning = async (id: string) => {
    const res = await getDetailJobById(id);
    setJobDetail(res);
    const isExpired = res.expiredTime && new Date(res.expiredTime) < new Date();

    if (res.status === IN_PROGRESS && isExpired) {
      setStatus("error");
      setVisible(true);
      return;
    }

    if (res.status === IN_PROGRESS) {
      setStatus("doing");
      setVisible(true);
      setTimeout(() => {
        getDetailJobRunning(id);
      }, 3000);
    }

    if (res.status === SUCCESS) {
      setStatus("success");
      setVisible(true);
    }
    if (res.status === ERROR) {
      setStatus("error");
      setVisible(true);
    }
  };

  const actions = [
    {
      label: "Lọc dữ liệu",
      icon: "pi pi-fw pi-filter",
      className: "iam-toolbar iam-toolbar-secondary",
      command: () => setDisplayFilter(true),
    },
    // {
    //   label: "Kết xuất excel",
    //   icon: "pi pi-fw pi-file-excel",
    //   className: "iam-toolbar iam-toolbar-secondary",
    //   command: downloadExcel,
    // },

    {
      label: "Kết xuất excel",
      icon: "pi pi-fw pi-file-excel",
      className: "iam-toolbar iam-toolbar-secondary",
      disabled: isTableEmpty,
      command: async () => {
        const accessToken = cookie.get("access_token_report");
        const refreshExpiredAtString = cookie.get("refreshExpiredAt");

        const isLoginRequired = checkLoginRequired(
          accessToken,
          refreshExpiredAtString
        );

        if (isLoginRequired) {
          await loginJob();
        }
        let resCurrent = await getCurrentJob();

        const runningJobs = resCurrent.filter(
          (job: any) => job.status === IN_PROGRESS
        );
        if (status === "doing") {
          return ToastService.error("Đang có tiến trình kết xuất khác. Vui lòng đợi.");
        }
        if (runningJobs?.length === 0) {
          await createJob(USE_INVOICE_REPORT, filter);
          setJobDetail(null);
          setVisible(true);
          resCurrent = await getCurrentJob();
        } else {
          ToastService.error("Đang có tiến trình kết xuất khác. Vui lòng đợi.");
        }

        if (resCurrent.length === 0) {
          setStatus("doing");
          return;
        }

        const jobToTrack =
          resCurrent.find((job: any) => job.status === IN_PROGRESS) ||
          resCurrent[0];
        setJobDetail(jobToTrack);

        const res = await getDetailJobById(jobToTrack?.jobId!);
        localStorage.setItem("jobIdRunning", jobToTrack?.jobId!);

        switch (res.status) {
          case IN_PROGRESS:
            setStatus("doing");
            break;
          case SUCCESS:
            setStatus("success");
            break;
          case ERROR:
            setStatus("error");
            break;
        }

        if (res.status === SUCCESS) {
          setJobDetail(res);
        }

        if (res.status === IN_PROGRESS) {
          setMinimize(false);
          getDetailJobRunning(jobToTrack?.jobId!);
        }

        setVisible(true);
      },
    },
  ];

  return (
    <Fragment>
      <MegaMenu model={actions} />
      <Filter
        header="Báo cáo tình hình sử dụng hóa đơn"
        display={displayFilter}
        setDisplay={setDisplayFilter}
        search={search}
        hiddenFields={["buyerTaxCode", "invoiceStatus", "sendTaxStatus"]}
      />

      <div className="p-datatable p-component p-datatable-responsive-scroll p-datatable-gridlines p-datatable-sm">
        <div className="p-datatable-wrapper">
          <table className="p-datatable-table">
            <colgroup>
              <col style={{ width: "50px" }} />
              <col style={{ width: "150px" }} />
              <col style={{ minWidth: "100px" }} />
              <col style={{ minWidth: "100px" }} />
              <col style={{ minWidth: "100px" }} />
              <col style={{ minWidth: "100px" }} />
              <col style={{ minWidth: "100px" }} />
              <col style={{ minWidth: "100px" }} />
              <col style={{ minWidth: "150px" }} />
              <col style={{ minWidth: "150px" }} />
              <col style={{ minWidth: "150px" }} />
            </colgroup>
            <thead className="p-datatable-thead">
              <tr role="row">
                <th
                  rowSpan={2}
                  role="columnheader"
                  className="justify-content-center"
                >
                  <div className="p-column-header-content">
                    <span className="p-column-title">#</span>
                  </div>
                </th>
                <th rowSpan={2} role="columnheader">
                  <div className="p-column-header-content">
                    <span className="p-column-title">Ký hiệu</span>
                  </div>
                </th>
                <th colSpan={6} role="columnheader">
                  <div className="p-column-header-content">
                    <span className="p-column-title">
                      Trạng thái hóa đơn gửi thành công
                    </span>
                  </div>
                </th>
                <th rowSpan={2} role="columnheader">
                  <div className="p-column-header-content">
                    <span className="p-column-title">
                      Tổng số hóa đơn gửi thành công
                    </span>
                  </div>
                </th>
                <th rowSpan={2} role="columnheader">
                  <div className="p-column-header-content">
                    <span className="p-column-title">
                      Tổng số hóa đơn gửi không thành công
                    </span>
                  </div>
                </th>
                <th rowSpan={2} role="columnheader">
                  <div className="p-column-header-content">
                    <span className="p-column-title">
                      Tổng số hóa đơn sử dụng
                    </span>
                  </div>
                </th>
              </tr>
              <tr role="row">
                <th role="columnheader">
                  <div className="p-column-header-content">
                    <span className="p-column-title">Gốc</span>
                  </div>
                </th>
                <th role="columnheader">
                  <div className="p-column-header-content">
                    <span className="p-column-title">Thay thế</span>
                  </div>
                </th>
                <th role="columnheader">
                  <div className="p-column-header-content">
                    <span className="p-column-title">Điều chỉnh</span>
                  </div>
                </th>
                <th role="columnheader">
                  <div className="p-column-header-content">
                    <span className="p-column-title">Bị thay thế</span>
                  </div>
                </th>
                <th role="columnheader">
                  <div className="p-column-header-content">
                    <span className="p-column-title">Bị điều chỉnh</span>
                  </div>
                </th>
                <th role="columnheader">
                  <div className="p-column-header-content">
                    <span className="p-column-title">Hủy</span>
                  </div>
                </th>
              </tr>
            </thead>
            <tbody className="p-datatable-tbody">
              {items?.map((item, index) => (
                <tr key={index}>
                  <td className="text-center">{index + 1}</td>
                  <td className="text-center">{item.symbol}</td>
                  <td className="text-center">
                    {FormatDisplay.number(item.original)}
                  </td>
                  <td className="text-center">
                    {FormatDisplay.number(item.substitute)}
                  </td>
                  <td className="text-center">
                    {FormatDisplay.number(item.adjust)}
                  </td>
                  <td className="text-center">
                    {FormatDisplay.number(item.substituted)}
                  </td>
                  <td className="text-center">
                    {FormatDisplay.number(item.adjusted)}
                  </td>
                  <td className="text-center">
                    {FormatDisplay.number(item.cancel)}
                  </td>
                  <td className="text-center">
                    {FormatDisplay.number(item.success)}
                  </td>
                  <td className="text-center">
                    {FormatDisplay.number(item.error)}
                  </td>
                  <td className="text-center">
                    {FormatDisplay.number(item.totalUse)}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </Fragment>
  );
}
function setJobDetail(arg0: any) {
  throw new Error("Function not implemented.");
}
